import FieldProto from "../../../../fields3/proto/field-proto";
import FieldConfig from "../../../../fields3/proto/field-config";
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups";


export default class FieldTaskTitle extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Task Title";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Task title"

        this.variableName       = '{TASK-TITLE}'
    }

    sortValue(value:string) { return value}

}